// import React from "react";
// import "../styles/App.css";
// import { FaLinkedin, FaGithub, FaEnvelope  } from "react-icons/fa";
// import { FaSquareXTwitter } from "react-icons/fa6";

// import VantaBackground from "./background/background2/VantaBackground";

// function Contact() {
//   return (
//     // <section className="contact">
//     //   <h2>Contact Me</h2>
//     //   <p>Email: <a href="mailto:sarthak.bhojane02@gmail.com">sarthak.bhojane02@gmail.com</a></p>
//     //   <p>Phone: 7709437063</p>
//     //   <p>LinkedIn: <a href="https://www.linkedin.com/in/sarthak-bhojane">sarthak-bhojane</a></p>
//     //   <p>GitHub: <a href="https://github.com/sarthak-bhojane">sarthak-bhojane</a></p>
//     // </section>


// <VantaBackground>
// <section className="contact" id="contact">
// <h2>Contact Me</h2>
// <div className="social-icons">
//   <a href="https://www.linkedin.com/in/sarthak-bhojane-6a1896237/" target="_blank" rel="noopener noreferrer" className="icon linkedin">
//     <FaLinkedin />
//   </a>
//   <a href="https://github.com/sarthak-bhojane" target="_blank" rel="noopener noreferrer" className="icon github">
//     <FaGithub />
//   </a>
//   <a href="mailto:sarthak.bhojane02@gmail.com" className="icon email">
//     <FaEnvelope />
//   </a>

//   <a href="https://twitter.com/sarthakBhojane" className="icon twitter">
//   <FaSquareXTwitter  />
//   </a>

// </div>
// </section> 




// </VantaBackground>

//   );
// }

// export default Contact;

import React from "react";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
// import VantaBackground from "./background/background2/VantaBackground";
import "../styles/App.css";

function Contact() {
  return (
    // <VantaBackground>
      <section className="contact" id="contact" style={{ position: "relative", zIndex: 1 }}>


 
        <div className="card">
        <h3 style={{ color: "#007bff" }}> READY TO BUILD SOMETHING AMAZING?</h3>
        <p>
         Let's discuss how I can help you create products that users love and drive real business results.
          </p>
      

        <h2>Contact Me</h2>
        <div className="social-icons">
          <a
            href="https://www.linkedin.com/in/sarthak-bhojane-6a1896237/"
            target="_blank"
            rel="noopener noreferrer"
            className="icon linkedin"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/sarthak-bhojane"
            target="_blank"
            rel="noopener noreferrer"
            className="icon github"
          >
            <FaGithub />
          </a>
          <a href="mailto:sarthak.bhojane02@gmail.com" className="icon email">
            <FaEnvelope />
          </a>

          <a href="https://twitter.com/sarthakBhojane" className="icon twitter">
            <FaSquareXTwitter />
          </a>
        </div>

        </div>
        
      </section>
    // </VantaBackground>
  );
}

export default Contact;
